/*
 * SAFIR homepage hero — video only, no poster/still-image system.
 *
 * Product Owner final freeze: this is intentionally not a state machine.
 * There is nothing to sequence, hide, reveal, or clean up. The only job of
 * this script is to attempt muted autoplay once, and to make the one
 * accessibility call the browser can't make on its own: skip that attempt
 * entirely under prefers-reduced-motion, since HTML has no native way to
 * gate the `autoplay` attribute on a media query.
 *
 * The video plays exactly once (`loop` is force-set false, matching the
 * markup already omitting the `loop` attribute) and is never paused, reset,
 * or replaced when it ends — the browser's own default behavior already
 * leaves it sitting on its final decoded frame, which is exactly the wanted
 * end state, so nothing here needs to touch it after playback starts.
 */
(function () {
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  Array.prototype.forEach.call(document.querySelectorAll('.safir-hero__video'), function (video) {
    video.loop = false;
    video.muted = true;

    if (motionQuery.matches) {
      console.info('[SAFIR hero] reduced motion is on; autoplay is not attempted.');
      return;
    }

    try {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function (error) {
          console.info('[SAFIR hero] autoplay was blocked; the video remains available for manual playback.', {
            name: error && error.name,
            message: error && error.message,
          });
        });
      }
    } catch (error) {
      console.info('[SAFIR hero] autoplay threw synchronously; the video remains available for manual playback.', error);
    }
  });
})();
